import { Box, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Transaction } from '../../../../../services/transaction.types';

interface CommentSectionProps {
    formValues: Partial<Transaction>;
    onCommentChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CommentSection: React.FC<CommentSectionProps> = ({ formValues, onCommentChange }) => {
    const { t } = useTranslation();
    return (
        <Box>
            <TextField
                fullWidth
                label={t('transactions.modal.form.comment')}
                multiline
                rows={3}
                value={formValues.comment}
                onChange={onCommentChange}
                sx={{
                    '& .MuiInputBase-root': {
                        borderRadius: 1,
                        padding: 1.5
                    },
                }}
            />
        </Box>
    );
};

export default CommentSection;
